<template>
  <vbt-content-box
    title="Information"
    v-bind="$attrs"
  >
    <v-layout
      :class="$_themeTextColorClass"
      class="mt-2"
    >
      <v-flex lg4>
        <v-layout column>
          <v-layout class="mb-1">
            <strong class="mr-1 vbt-strong-label">
              Create Date:
            </strong>
            {{ formatDate(inputMessage.created) }}
          </v-layout>
          <v-layout class="mb-1">
            <strong class="mr-1 vbt-strong-label">
              Order Outer ID:
            </strong>
            <router-link
              v-if="inputMessage.orderOuterId"
              :class="$_themeTextColorClass"
              :to="{
                name: 'order',
                params: { id: inputMessage.orderOuterId },
                query: { suffix },
              }"
            >
              {{ inputMessage.orderOuterId }}
            </router-link>
            <span v-else>
              -
            </span>
          </v-layout>
        </v-layout>
        <v-layout>
          <strong class="mr-1 vbt-strong-label">
            Order Item Outer ID:
          </strong>
          {{ inputMessage.orderItemOuterId || '-' }}
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout column>
          <v-layout class="mb-1">
            <strong class="mr-1 vbt-strong-label">
              Type:
            </strong>
            {{ inputMessage.type }}
          </v-layout>
        </v-layout>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            IR Success:
          </strong>
          <kernel-status-badge :status="irResultByValue[inputMessage.irSuccess]">
            {{ inputMessage.irSuccess }}
          </kernel-status-badge>
        </v-layout>
      </v-flex>
      <v-flex lg4>
        <v-layout class="mb-1">
          <strong class="mr-1 vbt-strong-label">
            Response Status Code:
          </strong>
          {{ inputMessage.responseStatusCode }}
        </v-layout>
      </v-flex>
    </v-layout>
  </vbt-content-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { provideThemeSettings } from '@mixins';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { formatDate } from '@helpers';

export default {
  name: 'KernelInputMessageInfoView',
  mixins: [
    provideThemeSettings,
  ],
  props: {
    inputMessage: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapGetters(EnumsNamespace, ['irResultByValue']),
  },
  methods: {
    formatDate,
  },
};
</script>
